import { getAccessControl } from "@store/accessControl/actions";
import { selectOccupantOption } from "@store/occupantOption/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { projectType } from "utils/lookUpTable";

const ProjectHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const occupantOption = useSelector((state) =>
    Array.isArray(state?.occupantOption?.data)
      ? state?.occupantOption?.data
      : []
  );
  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || []
  );

  useEffect(() => {
    if (currentProject?.id) {
      dispatch(getAccessControl(currentProject.id));
      dispatch(selectOccupantOption(currentProject.id));
    }
  }, [currentProject?.id, dispatch]);

  const authData = useSelector((state) => state?.authdata?.data || null);
  const isFirstAccess = sessionStorage.getItem("firstAccess");
  const hasProjectRootAccess =
    accessControlData.projectFolderAccess == 1 ||
    accessControlData.rootLibraryAccess == 1;
  useEffect(() => {
    if (
      occupantOption?.length == 1 &&
      authData?.userType == 2 &&
      !hasProjectRootAccess &&
      !isFirstAccess
    ) {
      sessionStorage.setItem("firstAccess", 1);
      navigate(
        `/project-home/occupanthomepage?projectId=${occupantOption[0]?.id}&type=${projectType.occupant}`
      );
      return;
    }

    navigate(
      `/project-home/generalinformation?projectId=${currentProject?.id}&type=${projectType?.property}`
    );

    // window.location.reload();
  }, [currentProject, hasProjectRootAccess]);
  return <></>;
};

export default ProjectHome;
